module.exports = __webpack_public_path__ + "static/jane2-187aa797fc12bd71063eab38168b3b31.png";